import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './Error.module.scss';
import { Button } from 'src/components/common/button/Button';
import IconWarning from 'src/components/icons/IconWarning';

export const ErrorModal = ({show,title,children,onClose}) => {

    return (<Modal
        show={show}
        onHide={() => onClose()}
        animated="false"
        className="modal fade in theme-light"
        dialogClassName="modal-sm"
        backdropClassName="in"
    >
        <div className="modal-header no-border d-flex align-items-center justify-content-center">
            <IconWarning className={styles.icon}/>
            <Button className="close" onClick={() => onClose()}>
                <i className="icon-close-thin"/>
            </Button>
        </div>
        <div className={styles.modal_body}>
            <div className={styles.content}>
                <p className={styles.title}>{title}</p>
                {children!== null && <div>{children}</div>}
            </div>
        </div>
    </Modal>);
};
